import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CallService } from '@nutrix/data-access-calls';

/**
 * Global incoming-call overlay. Mounted once in the authenticated shell so a
 * patient's WhatsApp call rings on any page. Sits above every PrimeNG dialog.
 */
@Component({
  selector: 'nutrix-incoming-call',
  standalone: true,
  imports: [ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './incoming-call.component.html',
  styleUrl: './incoming-call.component.css',
})
export class IncomingCallComponent {
  readonly call = inject(CallService);

  readonly visible = computed(() => this.call.phase() === 'ringing-in');

  answer(): void {
    void this.call.answerIncoming();
  }

  reject(): void {
    void this.call.rejectIncoming();
  }
}
